export const JournalProcessingTemplateForm = [
  {
    header: {
      header: 'JournalDate',
      width: 17,
    },
    dataType: 'date',
  },
  {
    header: {
      header: 'JournalType',
      width: 17,
    },
  },
  {
    header: {
      header: 'RefNo',
      width: 17,
    },
  },
  {
    header: {
      header: 'JournalDescription',
      width: 40,
    },
  },
  {
    header: {
      header: 'MasterCOACode',
      width: 17,
    },
  },
  {
    header: {
      header: 'DepartmentCode',
      width: 17,
    },
  },
  {
    header: {
      header: 'Remark',
      width: 40,
    },
  },
  {
    header: {
      header: 'DocAmt',
      width: 15,
    },
    dataType: 'amount',
  },
]
